import React from 'react';
import clsx from 'clsx';

import scss from './ToolButton.module.scss';

function ToolButton({ title, isActive, onClick, children }) {
  return (
    <button
      type='button'
      className={clsx(scss.button, isActive && scss.buttonActive)}
      title={title}
      aria-label={title}
      aria-pressed={isActive}
      onClick={onClick}>
      {children}
    </button>
  );
}

export default ToolButton;
